import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Gauge, Settings, Fuel, PlayCircle } from "lucide-react";

const statusStyle = {
  available: { text: "Available", bg: "var(--gpm-green)", color: "var(--gpm-cream)" },
  hold: { text: "On Hold", bg: "var(--gpm-gold)", color: "#14291d" },
  sold: { text: "Sold", bg: "#7a2020", color: "#fff" },
};

const CarCard = ({ car }) => {
  const st = statusStyle[car.status] || statusStyle.available;
  return (
    <Link
      to={`/product/${car.slug}`}
      className="gpm-card group block bg-white border border-black/10 overflow-hidden transition-all duration-300 hover:shadow-2xl hover:-translate-y-1"
    >
      <div className="relative overflow-hidden aspect-[3/2]">
        <img
          src={car.images[0]}
          alt={car.title}
          className="gpm-card-img w-full h-full object-cover"
        />
        <span
          className="absolute top-4 left-4 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider"
          style={{ backgroundColor: st.bg, color: st.color }}
        >
          {st.text}
        </span>
        <span className="absolute top-4 right-4 px-3 py-1 text-[11px] font-semibold bg-black/60 text-white">
          {car.year}
        </span>
        {car.videoUrl && (
          <span className="absolute bottom-4 right-4 flex items-center gap-1 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wide bg-black/70 text-white rounded">
            <PlayCircle size={13} /> Video
          </span>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-serif-display text-xl font-semibold gpm-text-green leading-tight min-h-[3.2rem]">
          {car.title}
        </h3>
        <div className="flex items-center gap-4 text-[12px] text-gray-500 mt-2 mb-4">
          <span className="flex items-center gap-1"><Gauge size={13} /> {car.mileage} mi</span>
          <span className="flex items-center gap-1"><Settings size={13} /> {car.transmission}</span>
          <span className="flex items-center gap-1"><Fuel size={13} /> {car.fuel}</span>
        </div>
        <div className="flex items-center justify-between border-t border-black/10 pt-4">
          <span className="font-serif-display text-2xl font-bold gpm-text-green">{car.priceLabel}</span>
          <span className="flex items-center gap-1 text-xs font-semibold uppercase tracking-wide gpm-text-green group-hover:gpm-text-gold transition-colors">
            Details <ArrowRight size={15} />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CarCard;
